import { Box, Flex, FlexProps, Paper, StyleProp, UnstyledButton } from '@mantine/core';
import { ReactNode } from 'react';

import { deleteIcon } from '@assets';

interface ListElementProps extends Omit<FlexProps, 'children'> {
  children: ReactNode;
  onRemove?: () => void;
  canRemove?: boolean;
  disabled?: boolean;
  variant?: 'default' | 'paper';
  justify?: StyleProp<React.CSSProperties['justifyContent']>;
  align?: StyleProp<React.CSSProperties['alignItems']>;
  'data-pw'?: string;
}

export const ListElement: React.FC<ListElementProps> = ({
  children,
  onRemove,
  canRemove = true,
  disabled = false,
  variant = 'default',
  justify = 'flex-start',
  align = 'flex-start',
  'data-pw': dataPw,
  ...flexProps
}) => {
  const showDeleteButton = !disabled && canRemove && onRemove;

  const content = (
    <Flex justify={justify} align={align} data-pw={dataPw} {...flexProps}>
      <Box pos="relative" style={{ flex: 1 }}>
        {children}
      </Box>
      {showDeleteButton && (
        <UnstyledButton
          ml={10}
          mt={variant === 'paper' ? 10 : 0}
          onClick={(e) => {
            e.preventDefault();
            onRemove();
          }}
        >
          <img src={deleteIcon} alt="Delete" />
        </UnstyledButton>
      )}
    </Flex>
  );

  if (variant === 'paper') {
    return (
      <Paper shadow="xs" p="md" withBorder>
        {content}
      </Paper>
    );
  }

  return <Box mb="xs">{content}</Box>;
};
